import { render, staticRenderFns } from "./TabDocFirmado.vue?vue&type=template&id=2adf6992"
import script from "./TabDocFirmado.vue?vue&type=script&lang=js"
export * from "./TabDocFirmado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adf6992')) {
      api.createRecord('2adf6992', component.options)
    } else {
      api.reload('2adf6992', component.options)
    }
    module.hot.accept("./TabDocFirmado.vue?vue&type=template&id=2adf6992", function () {
      api.rerender('2adf6992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabDocFirmado.vue"
export default component.exports